import { useLocalizedText } from '../../../../hooks/localizedText';
import Modal from '@amzn/awsui-components-react/polaris/modal';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Button from '@amzn/awsui-components-react/polaris/button';

export interface CancelDraftModalProps {
  visible: boolean;
  loading?: boolean;
  variant?: 'wizard' | 'list';
  onConfirm: () => void;
  onDismiss: () => void;
}

export function CancelDraftModal({
  visible,
  loading,
  variant = 'wizard',
  onConfirm,
  onDismiss,
}: CancelDraftModalProps) {
  const { t } = useLocalizedText(['events', 'translation']);
  const prefix = variant === 'list' ? 'deleteDraftModal' : 'cancelDraftModal';

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={t(`${prefix}.title`)}
      closeAriaLabel={t(`${prefix}.closeAriaLabel`)}
      data-testid="cancel-draft-modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              {t(`${prefix}.dismiss`)}
            </Button>
            <Button variant="primary" onClick={onConfirm} loading={loading}>
              {t(`${prefix}.confirm`)}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      {t(`${prefix}.message`)}
    </Modal>
  );
}
